import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useSpring, animated } from '@react-spring/web';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Backdrop": Backdrop, "@mui/material/Box": Box, "@mui/material/Modal": Modal, "@mui/material/Button": Button, "@mui/material/Typography": Typography, "@react-spring/web": { useSpring, animated } } } });
export default ClientProvider;
